import React, { useEffect, useState } from 'react';
import '../css/GlobalCompetitionBanner.css'; // make sure you create this CSS file
import API from "../../api/axiosInstance";


const API_URL = process.env.REACT_APP_API_URL;

const GlobalCompetitionBanner = () => {
  const [activeCompetitions, setActivCompetitions] = useState([]);

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const res = await API.get(`${API_URL}/ems/competitions`);
        const active = res.data.filter(competition => competition.status === true);
        setActivCompetitions(active);
      } catch (error) {
        console.error('Error fetching competitions:', error);
      }
    };
    fetchCompetitions();
  }, []);

  if (activeCompetitions.length === 0) return null;

  return (
    <div className="global-competition-banner d-flex align-items-center p-3">
      {activeCompetitions.map(competition => (
        <div key={competition._id} className="d-flex align-items-center me-4">
          {competition.logo && (
            <img
              src={`${API_URL}/ems/${competition.logo.replace(/\\/g, '/')}`}
              alt="Event Logo"
              className="competition-logo me-2"
            />
          )}
          <div>
            <div className="fw-bold">{competition.name}</div>
            <div className="text-muted small d-flex align-items-center">
              <span className="status-dot bg-success me-1" />
              Active
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GlobalCompetitionBanner;
